export default "__VITE_ASSET__D4M9S0vo__"